import Vue from 'vue'
import './components'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store/store'
import HighchartsVue from "highcharts-vue";
import Highcharts from "highcharts";
import Moment from "moment";
import MomentTimeZone from "moment-timezone";
import dataModule from "highcharts/modules/data";

import VueNativeSock from 'vue-native-websocket'
import VuetifyDialog from 'vuetify-dialog'
import 'vuetify-dialog/dist/vuetify-dialog.css'
import axios from 'axios'
import './plugins/chartist'
import Carousel3d from 'vue-carousel-3d';
import DatetimePicker from 'vuetify-datetime-picker'
// (Optional) import 'vuetify-datetime-picker/src/stylus/main.styl'

Vue.use(DatetimePicker)
Vue.use(VuetifyDialog)
Vue.use(Carousel3d)

import VueTabulator from 'vue-tabulator';

Vue.use(VueTabulator);

// axios.get(`http://13.235.105.131:8082/api/server`)
// .then(response => {
//       console.log(response);
//       console.log(window.location)
//       axios.get(`http://13.235.105.131:8082/api/session`, {token:1571253547110})
//       .then(response => {
//         console.log(response.data);
//         Vue.use(VueNativeSock, `${process.env.VUE_APP_API_SOCKET_JAVA_URL}`, {
//           // protocol: 'rtms',
//           reconnection: true, // (Boolean) whether to reconnect automatically (false)
//           reconnectionAttempts: 5, // (Number) number of reconnection attempts before giving up (Infinity),
//           reconnectionDelay: 3000, // (Number) how long to initially wait before attempting a new (1000)
//         })
//       })
//       .catch(e => {
//         console.log(e)
//       })
// })
// .catch(e => {
//   console.log(e)
// })
Vue.use(VueNativeSock, `${process.env.VUE_APP_API_SOCKET_URL}`, {
  protocol: 'rtms',
  reconnection: true, // (Boolean) whether to reconnect automatically (false)
  reconnectionAttempts: 5, // (Number) number of reconnection attempts before giving up (Infinity),
  reconnectionDelay: 3000, // (Number) how long to initially wait before attempting a new (1000)
})

import { Icon }  from 'leaflet'
import 'leaflet/dist/leaflet.css'


// this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});
Vue.config.productionTip = false
MomentTimeZone();
dataModule(Highcharts);

Vue.use(HighchartsVue);

new Vue({
  store,
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
